<template>
    <div
        class="dropdown containerDropdownParent"
        :class="{
            'is-active': showDropDown,
        }"
    >
        <div
            :class="{
                loadingState: busy,
            }"
        >
            <search-input
                :label="label"
                :placeholder="placeholder"
                :hideLabelColon="hideLabelColon"
                :selectedItem="selectedItem"
                :busy="busy"
                @set-state="setState"
            />
        </div>

        <portal to="root-app">
            <search-drop-down
                ref="dropdown"
                :activeDropDown="showDropDown"
                :canQuery="querySearchHelpThree"
                :isEmpty="isEmpty"
                :starting="starting"
                :busy="loadingSearch"
                :query="querySearch"
            >
                <search-contacts
                    :filterSections="filterSections"
                    :counter="counter"
                    :starting="starting"
                    :contactsPipedriveSearch="contactsPipedriveSearch"
                    :contactsPipedriveSearchPagination="contactsPipedriveSearchPagination"
                    :contactsInfusionsoftSearch="contactsInfusionsoftSearch"
                    :contactsInfusionsoftSearchPagination="contactsInfusionsoftSearchPagination"
                    :contactsHubSpotSearch="contactsHubSpotSearch"
                    :contactsHubSpotSearchPagination="contactsHubSpotSearchPagination"
                    :contactsActiveCampaignSearch="contactsActiveCampaignSearch"
                    :contactsActiveCampaignSearchPagination="contactsActiveCampaignSearchPagination"
                    :contactsSalesforceSearch="contactsSalesforceSearch"
                    :contactsSalesforceSearchPagination="contactsSalesforceSearchPagination"
                    :contactsSearch="contactsSearch"
                    :contactsSearchPagination="contactsSearchPagination"
                    :searchLimit="searchLimit"
                    :totalSection="totalSection"
                    :query="querySearch"
                    @handle-section-click="handleSectionClick"
                    @enter="handleEnter"
                    @mouse-over="handleMouseOver"
                    @mouse-out="handleMouseOut"
                />
            </search-drop-down>
        </portal>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import { debounce } from 'lodash';
import InitialsMixin from '../../../mixins/initials';
import SearchContactMixin from '../../../mixins/search-contact.js';
import SearchContacts from './../../../views/Conversations/Search/Contacts/Contacts';
import SearchInput from './SearchInput';
import SearchDropDown from './SearchDropDown';
import { CancelToken } from 'core/api';

export default {
    emits: ['updateQuery', 'input'],
    
    components: {
        SearchInput,
        SearchContacts,
        SearchDropDown,
    },

    mixins: [InitialsMixin, SearchContactMixin],

    props: {
        form: { default: null },
        label: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        hideLabelColon: { type: Boolean, default: false },
    },

    data: () => ({
        counter: -1,
        focus: false,
        busy: false,
        starting: false,
        active: false,
        showDropDown: false,
        selectedItem: null,
    }),

    computed: {
        dropdownSettings() {
            return {
                valueField: 'id',
                searchField: ['label'],
                options: [],
                highlight: true,
                render: {
                    item: this.dropdownItem,
                },
                maxItems: 1,
                notClearTextInput: true,
                onSearchChange: (value) => {
                    this.$emit('updateQuery', value);
                },
            };
        },

        dropdown() {
            return this.$refs.dropdown.$refs.dropdown.$el.selectize;
        },

        ...mapState(stores.Search, ['searchDisabled']),
    },

    watch: {
        querySearch(query) {
            this.resetItems();
            this.active = false;
            this.resetSourceAxios();

            if (this.searchDisabled) return;

            this.busy = false;

            if (!this.busy) {
                this.debounceSearch();
            }
        },

        showDropDown() {
            this.initResize();
        },

        selectedItem(item) {
            if (!item) this.$emit('input', null);
        },
    },

    methods: {
        init() {
            this.debounceSearch = debounce(this.search, 500);

            this.initResize();
        },

        initEvent() {
            window.document.addEventListener('click', this.handleOutSideHide);
            window.addEventListener('scroll', this.initResize);
            window.addEventListener('resize', this.initResize);

            const modalCardBody = document.querySelector('.modal-card-body');

            if (modalCardBody) {
                modalCardBody.addEventListener('scroll', this.initResize);
                modalCardBody.addEventListener('resize', this.initResize);
            }
        },

        async initResize() {
            let containerDropdown = document.querySelector('.searchDropDown--formInput');

            if (!containerDropdown) await this.$delay(100);

            const boundingParent = document
                .querySelector('.containerDropdownParent')
                .getBoundingClientRect();
            containerDropdown = document.querySelector('.searchDropDown--formInput');

            containerDropdown.style.position = 'fixed';
            containerDropdown.style.top = `${boundingParent.top + boundingParent.height - 5}px`;
            containerDropdown.style.left = `${boundingParent.left}px`;
            containerDropdown.style.width = `${boundingParent.width}px`;
            containerDropdown.style.zIndex = 99999;
        },

        reset() {
            this.$store.dispatch('searchUpdateState', {
                selectedTypeSearch: null,
                selectedTypeItemsSearch: [],
                querySearch: '',
                searchShowConversation: false,
            });
            this.resetItems();
        },

        removeEvent() {
            window.document.removeEventListener('click', this.handleOutSideHide);
            window.removeEventListener('scroll', this.initResize);
            window.removeEventListener('resize', this.initResize);

            const modalCardBody = document.querySelector('.modal-card-body');

            if (modalCardBody) {
                modalCardBody.removeEventListener('scroll', this.initResize);
                modalCardBody.removeEventListener('resize', this.initResize);
            }
        },

        async search() {
            this.busy = true;
            this.active = true;

            this.resetSourceAxios();

            this.source = CancelToken.source();

            try {
                if (this.querySearchThree) {
                    await Promise.all([
                        this.searchContacts(this.querySearch),
                        this.searchHubSpotContacts(this.querySearch),
                        this.searchActiveCampaignContacts(this.querySearch),
                        this.searchInfusionsoftContacts(this.querySearch),
                        this.searchPipedriveContacts(this.querySearch),
                        this.searchSalesforceContacts(this.querySearch),
                    ]);
                }
            } catch (err) {
                this.$log.error(e, this.$options.__file, 'search');

                this.resetItems();
            } finally {
                this.busy = false;
                this.source = null;
            }
        },

        handleUpdateSearch(value) {
            this.$store.dispatch('searchUpdateState', {
                querySearch: value,
            });
        },

        async handleEnter(item) {
            this.selectedItem = item;

            this.$emit('input', item);

            await this.$delay(10);

            this.$store.dispatch('searchUpdateState', {
                querySearch: '',
            });
            this.showDropDown = false;
        },

        handleMouseOver(i) {
            if (this.starting || this.isEmpty) {
                return;
            }

            this.counter = i;
        },

        handleMouseOut() {
            if (this.starting || this.isEmpty) {
                return;
            }

            this.counter = -1;
        },

        handleOutSideHide(e) {
            const containerDropdown = document.querySelector('.searchDropDown--formInput');

            if (
                this.$el &&
                !this.$el.contains(e.target) &&
                containerDropdown &&
                !containerDropdown.contains(e.target)
            ) {
                this.showDropDown = false;
            } else {
                this.showDropDown = true;
                this.initResize();
            }
        },

        setState(props) {
            for (let key in props) {
                this[key] = props[key];
            }
        },
    },

    mounted() {
        this.$rootEvents.$on('handleUpdateSearch', this.handleUpdateSearch);

        this.init();
        this.initEvent();
    },

    beforeUnmount() {
        this.$rootEvents.$off('handleUpdateSearch', this.handleUpdateSearch);

        this.reset();
        this.removeEvent();
    },
};
</script>
